/**
 * Offline-queue for clock events.
 * Stored in localStorage as JSON array.
 */
const KEY = 'sr_clock_offline_queue';

export function readQueue() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function writeQueue(arr) {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr || []));
  } catch (e) { console.warn('[clock-queue] op failed', e); }
}

export function enqueue(event) {
  const q = readQueue();
  q.push({ ...event, client_event_id: `evt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}` });
  writeQueue(q);
  return q.length;
}

export function clearQueue() {
  writeQueue([]);
}

export function queueSize() {
  return readQueue().length;
}
